import React, { Component } from 'react';
import { Helmet } from 'react-helmet'

import AdminAside from '../admin-aside';
import AdminMain from '../admin-main';
import AdminHeader from "../admin-header";
import StringConst from '../StringConst';
import { loggedIn } from '../../helper';
import Preloader from '../../components/UI/Preloader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
class Admin extends Component {
    
    componentDidMount() {
        // <script type="text/javascript" ></script>
        if (loggedIn()) {
            this.props.history.push(this.props.history.location.pathname);
        };
        const script = document.createElement("script");

        script.src = "https://rubixds.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/quqpmo/b/24/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=1d49d941";
        script.async = true;

        document.body.appendChild(script);

    }
    render() {
        let pageTitle = StringConst.getPageTitle(this.props.location.pathname)
        return (
            <section className="app app-admin">
                {/* Updated title for every page */}
                <Helmet>
                    <title>{pageTitle} | Rubix</title>
                </Helmet>

                {/* Navbar & Sidebar */}
                <AdminHeader {...this.props}></AdminHeader>
                <section className="app-body">
                    <AdminAside {...this.props} />
                    <AdminMain {...this.props} />
                </section>

                <Preloader></Preloader>
                <ToastContainer hideProgressBar={true} position="top-center"></ToastContainer>
            </section>
        );
    }
}

export default Admin;
